import type { ListFetcherCustomProps } from "./list-fetcher-custom.type";
import type { ListItem } from "../list.type";
import type { ApiPayloadList } from "@/services/api";

import { useEffect } from "react";

import { useCustom } from "@/hooks/queries";

import { formatListData } from "../list-fetcher";
import { useListContext } from "../list.context";

export const useListFetcherCustomHandler = <
  DataItem extends ListItem = ListItem,
  Metadata = unknown,
>({
  customEndpoint,
}: ListFetcherCustomProps) => {
  const { withMetadata, fetchParams, enabled, neverStale, setListData } =
    useListContext<DataItem, Metadata>();

  const { data, isLoading, isFetching } = useCustom<ApiPayloadList<DataItem>>(
    customEndpoint,
    {
      params: fetchParams,
      enabled,
      neverStale,
    }
  );

  useEffect(() => {
    const listData = formatListData<DataItem, Metadata>({
      data,
      withMetadata,
      isLoading,
      isFetching,
    });

    setListData(listData);
  }, [data, isLoading, isFetching, withMetadata]);
};
